import React from 'react';

const NotFound = () => {
  return (
    <main>
      <h1>404!</h1>
    </main>
  );
};

export default NotFound;
